export const CONTACT = {
  phone: "984-317-1447",
  phoneHref: "tel:+19843171447",
  email: "restassuredgrouptravel@outlook.com",
  emailHref: "mailto:restassuredgrouptravel@outlook.com",
};

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1571003123894-1f0594d2b5d9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBob3RlbCUyMHJlc29ydCUyMHN1bnNldHxlbnwwfHx8fDE3ODc3MDIyOTV8MA&ixlib=rb-4.1.0&q=85",
  corporate: "https://images.unsplash.com/photo-1762176263996-a0713a49ee4d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHw0fHxjb3Jwb3JhdGUlMjBjb25mZXJlbmNlJTIwYnVzaW5lc3MlMjBtZWV0aW5nJTIwaGFsbHxlbnwwfHx8fDE3ODc3MDIzNTR8MA&ixlib=rb-4.1.0&q=85",
  family: "https://images.pexels.com/photos/8841466/pexels-photo-8841466.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  sports: "https://images.unsplash.com/photo-1776251280249-9ee4a393747d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwzfHxzcG9ydHMlMjB0ZWFtJTIwY2VsZWJyYXRpb24lMjBzdGFkaXVtfGVufDB8fHx8MTc4NzcwMjM1NHww&ixlib=rb-4.1.0&q=85",
  social: "https://images.pexels.com/photos/12689014/pexels-photo-12689014.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  church: "https://images.pexels.com/photos/29422232/pexels-photo-29422232.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  manifesto1: "https://images.unsplash.com/photo-1720540244592-b4124532b318?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBob3RlbCUyMGxvYmJ5JTIwZ3JvdXAlMjB0cmF2ZWx8ZW58MHx8fHwxNzg3NzAyMzQ1fDA&ixlib=rb-4.1.0&q=85",
  manifesto2: "https://images.unsplash.com/photo-1659882751445-a846ab85d6c6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwyfHxncm91cCUyMG9mJTIwdHJhdmVsZXJzJTIwZnJpZW5kcyUyMGFkdmVudHVyZXxlbnwwfHx8fDE3ODc3MDIzNDV8MA&ixlib=rb-4.1.0&q=85",
  manifesto3: "https://images.unsplash.com/photo-1513338528991-696b7e768c3f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHw0fHxncm91cCUyMG9mJTIwdHJhdmVsZXJzJTIwZnJpZW5kcyUyMGFkdmVudHVyZXxlbnwwfHx8fDE3ODc3MDIzNDV8MA&ixlib=rb-4.1.0&q=85",
};

export const SERVICES = [
  {
    id: "corporate",
    tag: "01",
    title: "Corporate & Business",
    copy: "Conferences, retreats, and training weeks. We block rooms and meeting space so your team arrives aligned and rested.",
    img: IMAGES.corporate,
    span: "md:col-span-7 md:row-span-2",
  },
  {
    id: "family",
    tag: "02",
    title: "Family Reunions",
    copy: "Keep everyone under one roof. Group rates, connecting rooms, and space to gather.",
    img: IMAGES.family,
    span: "md:col-span-5",
  },
  {
    id: "sports",
    tag: "03",
    title: "Sports Teams",
    copy: "Tournament weekends handled — team blocks, early check-ins, and meals sorted.",
    img: IMAGES.sports,
    span: "md:col-span-5",
  },
  {
    id: "social",
    tag: "04",
    title: "Social Events",
    copy: "Weddings, milestones, and celebrations. Beautiful venues and blocks your guests will love.",
    img: IMAGES.social,
    span: "md:col-span-6",
  },
  {
    id: "church",
    tag: "05",
    title: "Church Events",
    copy: "Conventions, retreats, and mission trips coordinated for congregations of any size.",
    img: IMAGES.church,
    span: "md:col-span-6",
  },
];

export const PROCESS = [
  { n: "01", title: "Tell us about your group", copy: "Share your dates, headcount, and the kind of gathering you're planning. One short conversation." },
  { n: "02", title: "We source & negotiate", copy: "We shop trusted hotels and venues, then lock in group rates and room blocks on your behalf." },
  { n: "03", title: "We manage the details", copy: "Rooming lists, contracts, cut-off dates, and special requests — all handled by one coordinator." },
  { n: "04", title: "Your group arrives rested", copy: "Everyone checks in smoothly and stays together. You show up to enjoy the event, not manage it." },
];

export const CHAPTERS = [
  { n: "01", title: "We hold the room.", copy: "Group blocks are our entire craft. We negotiate directly with hotels and venues so your rates are protected and your rooms stay together — no scattered bookings, no surprises.", img: IMAGES.manifesto1 },
  { n: "02", title: "One point of contact.", copy: "You get a single dedicated coordinator from first quote to final check-out. Questions get answered by a person who already knows your event.", img: IMAGES.manifesto2 },
  { n: "03", title: "Rest, assured.", copy: "The name is the promise. We carry the logistics so families, teams, and organizations can simply be present for the moments that matter.", img: IMAGES.manifesto3 },
];

export const STATS = [
  { value: "1", label: "Dedicated coordinator" },
  { value: "24/7", label: "Support before you travel" },
  { value: "0", label: "Booking headaches" },
  { value: "100%", label: "Group travel focus" },
];

export const TESTIMONIALS = [
  { quote: "They blocked 40 rooms for our reunion and made it feel effortless. Everyone stayed in the same hotel, same rate, no chaos.", name: "Denise M.", role: "Family Reunion Organizer" },
  { quote: "Our tournament weekend ran on time because the team was rested and together. Rest Assured handled every detail.", name: "Coach R. Williams", role: "Youth Sports Program" },
  { quote: "The most responsive group coordinator we've worked with. Our annual conference has never been smoother.", name: "Angela T.", role: "Corporate Events Lead" },
];

export const EVENT_TYPES = [
  "Corporate & Business Travel",
  "Family Reunion",
  "Sports Team",
  "Social Event / Wedding",
  "Church Event",
  "Other",
];

export const MARQUEE_WORDS = [
  "Corporate Retreats", "Family Reunions", "Sports Teams", "Social Events",
  "Church Groups", "Weddings", "Conferences", "Hotel Blocks", "Venue Blocks",
];

export const SERVICE_AREAS = [
  "Atlanta", "Orlando", "Las Vegas", "Nashville", "Dallas", "New Orleans",
  "Charlotte", "Washington D.C.", "Chicago", "Myrtle Beach", "Phoenix", "San Antonio",
];

export const DESTINATIONS = [
  {
    city: "Orlando, FL",
    blurb: "Theme parks, resort pools, and family-sized suites — the go-to for reunions and youth sports weekends.",
    img: "https://images.unsplash.com/photo-1649016038610-40f1e8bd0e6b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHwxfHxPcmxhbmRvJTIwdGhlbWUlMjBwYXJrJTIwcmVzb3J0fGVufDB8fHx8MTc4NzcwNDQ3OHww&ixlib=rb-4.1.0&q=85",
  },
  {
    city: "Nashville, TN",
    blurb: "Live music, a walkable downtown, and lively venues built for celebrations and socials.",
    img: "https://images.pexels.com/photos/36077403/pexels-photo-36077403.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    city: "Las Vegas, NV",
    blurb: "Big room blocks, big entertainment, and hotels made for conferences and milestone trips.",
    img: "https://images.pexels.com/photos/11052956/pexels-photo-11052956.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    city: "New Orleans, LA",
    blurb: "Historic charm, unbeatable food, and character-filled venues for retreats and reunions.",
    img: "https://images.unsplash.com/photo-1549965738-e1aaf1168943?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwxfHxOZXclMjBPcmxlYW5zJTIwRnJlbmNoJTIwUXVhcnRlciUyMHN0cmVldHxlbnwwfHx8fDE3ODc3MDQ0Nzh8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    city: "Atlanta, GA",
    blurb: "A major hub with endless hotels, easy flights, and space for conferences of every size.",
    img: "https://images.unsplash.com/photo-1663601460253-aba72eea6edf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHwxfHxBdGxhbnRhJTIwR2VvcmdpYSUyMHNreWxpbmV8ZW58MHx8fHwxNzg3NzA0Njc2fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    city: "Myrtle Beach, SC",
    blurb: "Oceanfront blocks and boardwalk fun — a favorite for reunions and youth tournaments.",
    img: "https://images.unsplash.com/photo-1670615602465-1d0157b56cb7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwxfHxNeXJ0bGUlMjBCZWFjaCUyMG9jZWFuJTIwYm9hcmR3YWxrfGVufDB8fHx8MTc4NzcwNDY3Nnww&ixlib=rb-4.1.0&q=85",
  },
  {
    city: "Washington, D.C.",
    blurb: "Monuments, museums, and meeting space — ideal for schools, churches, and corporate trips.",
    img: "https://images.unsplash.com/photo-1624417963912-8532660d9de8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwyfHxXYXNoaW5ndG9uJTIwREMlMjBjYXBpdG9sJTIwbW9udW1lbnR8ZW58MHx8fHwxNzg3NzA0Njc2fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    city: "San Antonio, TX",
    blurb: "The River Walk, the Alamo, and warm hospitality — a memorable backdrop for any gathering.",
    img: "https://images.unsplash.com/photo-1605649666555-e321522c3023?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzV8MHwxfHNlYXJjaHwyfHxTYW4lMjBBbnRvbmlvJTIwcml2ZXJ3YWxrJTIwVGV4YXN8ZW58MHx8fHwxNzg3NzA0Njc2fDA&ixlib=rb-4.1.0&q=85",
  },
];

export const ABOUT = {
  image: "https://customer-assets-eiarnc6j.emergentagent.net/job_travel-group-portal/artifacts/j0ij09xk_786853747_1049994264619158_8951938006884008382_n.webp",
  paragraphs: [
    "I'm Matthew Barlow, Owner and CEO of Rest Assured Group Travel LLC. I started this business for one reason: to bring comfort to group travel.",
    "With 14 years of experience in the hotel industry, I know firsthand how tiring, uncertain, and frustrating group planning can be. Drawing on my background in hotel sales, I make sure my clients can truly \"rest assured\" that their group block accommodations are confirmed, secured, and ready when they arrive.",
    "My goal is simple: for you to feel exactly the way I'd want to feel when making group accommodations — cared for, confident, and completely at ease.",
  ],
  signatureName: "Matthew Barlow",
  signatureTitle: "Owner & CEO, Rest Assured Group Travel LLC",
  values: ["14 years in hotels", "Confirmed blocks", "One coordinator", "Nationwide reach"],
};

export const GALLERY = [
  { img: "https://images.unsplash.com/photo-1512918728675-ed5a9ecdebfd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHw0fHxsdXh1cnklMjBob3RlbCUyMHJvb20lMjBpbnRlcmlvciUyMGJlZHxlbnwwfHx8fDE3ODc3MDQ5NDR8MA&ixlib=rb-4.1.0&q=85", caption: "Guest suites" },
  { img: "https://images.unsplash.com/photo-1549294413-26f195200c16?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHwyfHxyZXNvcnQlMjBzd2ltbWluZyUyMHBvb2wlMjBwYWxtJTIwdHJlZXN8ZW58MHx8fHwxNzg3NzA0OTQ0fDA&ixlib=rb-4.1.0&q=85", caption: "Resort pools" },
  { img: "https://images.pexels.com/photos/38446275/pexels-photo-38446275.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940", caption: "Gala dinners" },
  { img: "https://images.unsplash.com/photo-1578898886225-c7c894047899?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBob3RlbCUyMHJvb20lMjBpbnRlcmlvciUyMGJlZHxlbnwwfHx8fDE3ODc3MDQ5NDR8MA&ixlib=rb-4.1.0&q=85", caption: "Restful rooms" },
  { img: "https://images.unsplash.com/photo-1720540244592-b4124532b318?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBob3RlbCUyMGxvYmJ5JTIwZ3JvdXAlMjB0cmF2ZWx8ZW58MHx8fHwxNzg3NzAyMzQ1fDA&ixlib=rb-4.1.0&q=85", caption: "Welcome lobbies" },
  { img: "https://images.pexels.com/photos/12689009/pexels-photo-12689009.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940", caption: "Grand ballrooms" },
  { img: "https://images.unsplash.com/photo-1536392706976-e486e2ba97af?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwxfHxldmVudCUyMGdhbGElMjBkaW5uZXIlMjBjZWxlYnJhdGlvbiUyMGxpZ2h0c3xlbnwwfHx8fDE3ODc3MDQ5NDR8MA&ixlib=rb-4.1.0&q=85", caption: "Banquet tables" },
  { img: "https://images.unsplash.com/photo-1706561611610-2ebe309993f2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHw0fHxyZXNvcnQlMjBzd2ltbWluZyUyMHBvb2wlMjBwYWxtJTIwdHJlZXN8ZW58MHx8fHwxNzg3NzA0OTQ0fDA&ixlib=rb-4.1.0&q=85", caption: "Poolside escapes" },
];

export const BUDGET_OPTIONS = [
  "Under $5,000",
  "$5,000 – $15,000",
  "$15,000 – $50,000",
  "$50,000+",
  "Not sure yet",
];



export const FAQS = [
  {
    q: "How many rooms make a group block?",
    a: "Typically 10 or more rooms for the same dates. If your group is around that size or larger, we can usually secure a dedicated block and a negotiated group rate.",
  },
  {
    q: "What does it cost to work with you?",
    a: "We'll lay out any costs clearly when we send your options — no hidden fees. Reach out and we'll put together a straightforward quote for your group.",
  },
  {
    q: "How far in advance should I book?",
    a: "The earlier the better — 3 to 6 months ahead is ideal for larger groups and peak dates — but we regularly handle shorter timelines too, so it's always worth asking.",
  },
  {
    q: "Can guests book and pay for their own rooms?",
    a: "Yes. Most blocks let each guest reserve their own room under your group rate with their own card, so you're not collecting money from everyone.",
  },
  {
    q: "What if we don't fill every room in the block?",
    a: "We negotiate reasonable cut-off dates and terms up front, so wherever possible you're not on the hook for unbooked rooms.",
  },
  {
    q: "What kinds of groups do you handle?",
    a: "Corporate teams, family reunions, sports teams, social events and weddings, and church groups — essentially any group that needs to stay together.",
  },
];


